const LEGACY_ROUTE_CHANGE = "labstream-legacy-route-change";
const VERSION_MISMATCH = "labstream-version-mismatch";

function isEmbedded() {
  return (
    typeof window !== "undefined" &&
    window.__LABSTREAM_EMBEDDED__ === true &&
    window.parent !== window
  );
}

function getInitialEmbeddedRoute() {
  if (!isEmbedded()) return null;
  return new URLSearchParams(window.location.search).get("route") || "/";
}

function postToHost(type, path) {
  if (!isEmbedded() || !window.parent || window.parent === window) return;
  window.parent.postMessage({ type, path }, window.location.origin);
}

function notifyLegacyRouteChange(path) {
  postToHost(LEGACY_ROUTE_CHANGE, path);
}

function notifyVersionMismatch() {
  if (isEmbedded()) {
    postToHost(VERSION_MISMATCH);
    return;
  }
  window.dispatchEvent(new Event("app-version-mismatch"));
}

function syncHostRoute(path) {
  notifyLegacyRouteChange(path);
}

function reloadHost() {
  if (isEmbedded() && window.parent && window.parent !== window) {
    window.parent.location.reload();
    return;
  }
  window.location.reload();
}

function redirectToLogin(router) {
  if (isEmbedded()) {
    notifyLegacyRouteChange("/login");
    return false;
  }
  router.push("/login");
  return true;
}

const embeddedNavigation = {
  isEmbedded,
  syncHostRoute,
  notifyLegacyRouteChange,
  notifyVersionMismatch,
  reloadHost,
};

export default embeddedNavigation;

export {
  getInitialEmbeddedRoute,
  isEmbedded,
  notifyLegacyRouteChange,
  notifyVersionMismatch,
  redirectToLogin,
  reloadHost,
  syncHostRoute,
};
